import React from 'react';

import { Button } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';
import { LoginMethod } from '@app/shared/types/common';

interface LoginOptionsProps {
  loginOption: LoginMethod;
  setLoginOption: React.Dispatch<React.SetStateAction<LoginMethod>>;
}

export function LoginOptions({ loginOption, setLoginOption }: LoginOptionsProps) {
  return (
    <div className="flex gap-2 rounded-[6px] bg-secondary-foreground/20 p-[3px]">
      <Button
        variant="secondary"
        size="sm"
        className={cn('w-full rounded-[6px]', loginOption === LoginMethod.TELEGRAM && 'bg-white')}
        type="button"
        onClick={() => {
          setLoginOption(LoginMethod.TELEGRAM);
        }}
        shadow="blue"
      >
        Telegram ID
      </Button>
      <Button
        variant="secondary"
        size="sm"
        className={cn('w-full rounded-[6px]', loginOption === LoginMethod.EMAIL && 'bg-white')}
        type="button"
        onClick={() => {
          setLoginOption(LoginMethod.EMAIL);
        }}
        shadow="blue"
      >
        Email
      </Button>
    </div>
  );
}
